export enum ExchangeStatus {
    DELIVERED = 'ENVIADO',
    REJECTED = 'NO ENVIADO',
    PENDING = 'PENDIENTE',
    CANCELLED = 'CANCELADO',
    RECIEVED = 'RECIBIDO',
    NOT_RECEIVED = 'NO RECIBIDO'
  };

